import React from 'react';
import ArrSelectionChip, {
  ArrSelectionChipData,
} from '../../../components/common/arr-selection-chip/ArrSelectionChip';

const mockData: ArrSelectionChipData = {
  id: '1',
  label: 'Test Filter',
  type: 'category',
  isSelected: false,
};

const mockDataIsSelected: ArrSelectionChipData = {
  id: '1',
  label: 'Test Filter',
  type: 'category',
  isSelected: true,
};
const TextAreaDemo: React.FC = () => {
  const handleChange = (event: any, param: ArrSelectionChipData) => {
    console.log(param);
  };
  return (
    <div
      style={{
        display: 'flex',
        gap: '10px',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '20px',
      }}
    >
      <h2>Selection Chip Demo </h2>
      <br></br>
      <h2>Selection Chip (V2)</h2>
      <div
        style={{
          display: 'flex',
          gap: '10px',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '20px',
        }}
      >
        <ArrSelectionChip
          filterData={mockData}
          onClick={handleChange}
          isFilterInactive={false}
          variant="v2"
        />
        <br />
        <br />
        <ArrSelectionChip
          filterData={mockData}
          onClick={handleChange}
          isFilterInactive={true}
          variant="v2"
        />
        <br />
        <br />
        <ArrSelectionChip
          filterData={mockDataIsSelected}
          onClick={handleChange}
          isFilterInactive={false}
          variant="v2"
        />
        <br />
        <br />
        <ArrSelectionChip
          filterData={mockData}
          onClick={handleChange}
          isFilterInactive={false}
          showCloseIcon={true}
          variant="v2"
        />
        <br />
        <br />
        <ArrSelectionChip
          filterData={mockData}
          onClick={handleChange}
          isFilterInactive={false}
          variant="v2"
          noIcon={true}
        />
        <br />
        <br />
        <ArrSelectionChip
          filterData={mockData}
          onClick={handleChange}
          isFilterInactive={true}
          showCloseIcon={true}
          variant="v2"
        />
      </div>
      <br></br>
      <h2>Selection Chip (V1)</h2>
      <div
        style={{
          display: 'flex',
          gap: '10px',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '20px',
        }}
      >
        <ArrSelectionChip
          filterData={mockData}
          onClick={handleChange}
          isFilterInactive={false}
        />
        <br />
        <br />
        <ArrSelectionChip
          filterData={mockData}
          onClick={handleChange}
          isFilterInactive={true}
        />
        <br />
        <br />
        <ArrSelectionChip
          filterData={mockDataIsSelected}
          onClick={handleChange}
          isFilterInactive={false}
        />
        <br />
        <br />
        <ArrSelectionChip
          filterData={mockData}
          onClick={handleChange}
          isFilterInactive={false}
          showCloseIcon={true}
        />
        <br />
        <br />
        <ArrSelectionChip
          filterData={mockData}
          onClick={handleChange}
          isFilterInactive={false}
          noIcon={true}
        />
        <br />
        <br />
        <ArrSelectionChip
          filterData={mockData}
          onClick={handleChange}
          isFilterInactive={true}
          showCloseIcon={true}
        />
      </div>
    </div>
  );
};

export default TextAreaDemo;
